export const GRAMMAR_SESSION_OUTCOMES = ['pass', 'hold', 'fail'] as const;

export type GrammarSessionOutcomeType = (typeof GRAMMAR_SESSION_OUTCOMES)[number];
